/* eslint-disable no-await-in-loop */
import { ExportFormatterFactory } from "./exportFormatter/index.js";
import Model from "./ExportModel.js";
class Exporter {
  constructor(model) {
    this.model = model;
    this.exportFormatter = ExportFormatterFactory.create(Model.getFormatter(this.model), {
      exportModel: this.model
    });
  }
  async export(iterator) {
    let res;
    const fields = Model.getFields(this.model);
    this.exportFormatter.init(fields);
    while (iterator.hasNext(res)) {
      try {
        res = await iterator.next(fields);
        this.exportFormatter.writeData(res, fields);
      } catch (err) {
        this.onError(err);
      }
    }
    this.exportFormatter.end();
  }
  onError(err) {
    console.error(err);
    this.exportFormatter.onError(err);
  }
}
export default Exporter;